import { render } from "./InscriptionsFilters.vue?vue&type=template&id=2232f1a9"
import script from "./InscriptionsFilters.vue?vue&type=script&lang=js"
export * from "./InscriptionsFilters.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__